import {
  useAdminMenuItems,
  useGameMenuItems,
  useGeneralMenuItems,
  useTournamentMenuItems,
} from 'app/hooks/left-side-menu';
import React, { useCallback } from 'react';
import { ActionGuard } from 'shared/components/ActionGuard';

import { useStyles } from './LeftSidebar.styles';
import { Box, Divider } from '@mui/material';
import { SidebarHeader } from 'app/components/Sidebar/SidebarHeader';
import { SidebarItem } from 'app/components/Sidebar/SidebarItem';
import { GameNavigationMenuItem, NavigationMenuItem } from 'app/interfaces/sidebar';
import { GameMenuItem } from 'app/components/Sidebar/GameMenu/GameMenuItem';
import { AboutMenu } from '../AboutMenu';

export const LeftSidebar = () => {
  const { classes } = useStyles();
  const { generalMenuItems } = useGeneralMenuItems();
  const { tournamentMenuItems } = useTournamentMenuItems();
  const { gameMenuItems } = useGameMenuItems();
  const { adminMenuItems } = useAdminMenuItems();

  const onClickHandler = useCallback((menuItem: NavigationMenuItem) => menuItem?.onClick(), []);
  const onEditClickHandler = useCallback(
    (menuItem: GameNavigationMenuItem) => menuItem?.onEdit(),
    []
  );

  return (
    <>
      <Divider />
      <Box className={classes.root}>
        <Box className={classes.container}>
          {generalMenuItems.map((item) => (
            <ActionGuard key={item.label} disabled={item?.isAllowedWithoutAuthorization}>
              <SidebarItem
                item={item}
                startIcon={item.icon}
                onClick={onClickHandler}
                className={classes.navigationItem}
              />
            </ActionGuard>
          ))}

          {Boolean(tournamentMenuItems?.length) && (
            <>
              <Divider />
              <SidebarHeader value="Tournament Creator" />
              {tournamentMenuItems.map((item) => (
                <ActionGuard key={item.label} disabled={item?.isAllowedWithoutAuthorization}>
                  <SidebarItem
                    item={item}
                    startIcon={item.icon}
                    onClick={onClickHandler}
                    className={classes.navigationItem}
                  />
                </ActionGuard>
              ))}
            </>
          )}

          <Divider />
          <SidebarHeader value="Games" />
          {gameMenuItems.map((item) => (
            <GameMenuItem
              key={item.label}
              item={item}
              startIcon={item.icon}
              onClick={onClickHandler}
              onEdit={onEditClickHandler}
              className={classes.gameNavigationItem}
              height={40}
            />
          ))}

          {Boolean(adminMenuItems?.length) && (
            <>
              <Divider />
              <SidebarHeader value="Admin" />
              {adminMenuItems.map((item) => (
                <ActionGuard key={item.label}>
                  <SidebarItem
                    item={item}
                    startIcon={item.icon}
                    onClick={onClickHandler}
                    className={classes.navigationItem}
                  />
                </ActionGuard>
              ))}
            </>
          )}

          <Divider />
          <SidebarHeader value="About" />
          <AboutMenu />
        </Box>
      </Box>
    </>
  );
};
